<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Assign Staff" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Staff</h4>
                </div>
                <div class="card-body">
                 <template v-if="$store.getters.getLoggedInUser?.parent_user_id === 0">
                   <div class="row" id="mainAccount">
                     <div class="card-header d-flex align-items-center p-1 w-50">
                       <div class="custom-control custom-switch">
                         <input
                             id="toggle-mainAccount"
                             type="checkbox"
                             class="custom-control-input"
                             v-model="mainAccount"
                             @click.stop
                         />
                         <label
                             class="custom-control-label"
                             for="toggle-mainAccount"
                         >
                           Main Account
                         </label>
                       </div>

                       <div
                           v-show="mainAccountObj?.username !== ''"
                           class="ml-auto"
                           data-toggle="collapse"
                           data-target="#collapse-mainAccount"
                           aria-expanded="false"
                           aria-controls="collapse-mainAccount"
                       >
                         <span class="text-primary" style="cursor: pointer;"><img width="30" height="30" src="https://www.svgrepo.com/show/282120/settings-gear.svg" /></span>
                       </div>
                     </div>
                   </div>
                   <div class="row mb-1">
                     <div class="col-12">
                       <div
                           id="collapse-mainAccount"
                           class="collapse m-1"
                           aria-labelledby="heading-mainAccount"
                           data-parent="#mainAccount"
                       >
                         <div class="card-body badge-glow border-secondary" style="border-radius: .8rem">
                           <div class="d-flex align-items-center mb-2">
                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user font-medium-3"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                             <h4 class="mb-0 ml-50">Reset Password</h4>
                           </div>
                           <div class="row">
                             <div class="col-6 col-md-3 ml-sm-2">
                               <p class="font-weight-bold mb-1">Username: {{mainAccountObj?.username }}</p>
                               <button type="button" class="btn btn-outline-success btn-sm waves-effect" @click="resetPassword(mainAccountObj)">Reset Password</button>
                             </div>
                           </div>
                           <div class="d-flex align-items-center mt-2 mb-2">
                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-link font-medium-3"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
                             <h4 class="mb-0 ml-50">Terminal Configuration</h4>
                           </div>
                           <div class="row">
                             <div class="col-6 col-md-3 ml-sm-2">
                               <button type="button" class="btn btn-sm btn-outline-success waves-effect" @click="terminalConfig(mainAccountObj)">Manage</button>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </template>
                  <Form class="form form-horizontal">
                    <div v-if="mainLoader"  class="spinner-border spinner-border"></div>
                    <div class="row" v-else>
                      <h6 class="section-label mx-1 mb-2">Staffs</h6>
                      <div id="staffAccordion" class="col-12">
                        <div class="card mb-0" v-for="(item, index) in staffList" :key="index">

                          <div class="card-header d-flex align-items-center p-1 w-50">

                            <div class="custom-control custom-switch">
                              <span class="mr-25">{{ index+1+") " }}</span>
                              <input
                                  v-if="typeof item.checked !== 'undefined'"
                                  :id="'toggle-' + index"
                                  type="checkbox"
                                  class="custom-control-input"
                                  v-model="item.checked"
                                  @click.stop
                              />
                              <label
                                  :class="typeof item.checked !== 'undefined' ? 'custom-control-label' : ''"
                                  :for="'toggle-' + index"
                              >
                                {{ item.first_name + ' ' + item.last_name }}
                              </label>
                            </div>
                            <!-- Accordion Toggle -->
                            <div
                                v-show="item.username !== ''"
                                class="ml-auto"
                                data-toggle="collapse"
                                :data-target="'#collapse' + index"
                                aria-expanded="false"
                                :aria-controls="'collapse' + index"
                            >
                              <span class="text-primary" style="cursor: pointer;"><img width="30" height="30" src="https://www.svgrepo.com/show/282120/settings-gear.svg" /></span>
                            </div>
                          </div>

                          <!-- Accordion Content -->
                          <div
                              :id="'collapse' + index"
                              class="collapse m-1"
                              aria-labelledby="'heading' + index"
                              data-parent="#staffAccordion"
                          >
                            <div class="card-body badge-glow border-secondary" style="border-radius: .8rem">
                              <div class="d-flex align-items-center mb-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user font-medium-3"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                <h4 class="mb-0 ml-50">Reset Password</h4>
                              </div>
                              <div class="row">
                                <div class="col-6 col-md-3 ml-sm-2">
                                  <p class="font-weight-bold mb-1">Username: {{ item.username }}</p>
                                  <button type="button" class="btn btn-outline-success btn-sm waves-effect" @click="resetPassword(item)">Reset Password</button>
                                </div>
                              </div>
                              <div class="d-flex align-items-center mt-2 mb-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-link font-medium-3"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
                                <h4 class="mb-0 ml-50">Terminal Configuration</h4>
                              </div>
                              <div class="row">
                                <div class="col-6 col-md-3 ml-sm-2">
                                  <button type="button" class="btn btn-sm btn-outline-success waves-effect" @click="terminalConfig(item)">Manage</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <Button class="btn btn-primary mr-1 mt-2 btn-sm" @click="sendCall" :loading="loader">Save</Button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary mt-2 btn-sm"
                            @click="$router.push({ name: 'pos-devices' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to reset password?"
                       title="Reset Password"
                       :image="`${publicPath}images/confirm.png`" @hide="showConfirmationModal = false"></ConfirmationModal>
    <TerminalConfigModal :posStaff="selectedItem" :show="showTerminalConfigModal" @hide="showTerminalConfigModal = false"></TerminalConfigModal>
  </div>
  <!-- END: Content-->
</template>

<script>
import Button from "@/components/common/Button.vue";
import TerminalConfigModal from "@/pages/dashboard/pos/TerminalConfigModal.vue";
import terminalConfigModal from "@/pages/dashboard/pos/TerminalConfigModal.vue";

export default {
  computed: {
    terminalConfigModal() {
      return terminalConfigModal
    }
  },
  components: {TerminalConfigModal, Button},
  mounted() {
    if(this.$store.getters.getLoggedInUser){
      let loggedInUser = this.$store.getters.getLoggedInUser
      console.log(loggedInUser)
      this.mainAccountObj = {
        id: loggedInUser.id,
        first_name: loggedInUser.first_name,
        last_name: loggedInUser.last_name,
        username: '',
        pivot:{
          id:loggedInUser.id,
          username:loggedInUser.first_name,
          settings:null
        }
      }
    }

    this.getStaffs()
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'POS'},
        {name: 'Assign Staff'},
      ],
      loader: false,
      showTerminalConfigModal: false,
      staffList: [],
      tempStaffList: [],
      staffFeatures: {},
      mainLoader: false,
      showConfirmationModal: false,
      selectedStaffForReset:'',
      selectedItem: null,
      mainAccount:false,
      mainAccountObj:null

    }
  },
  methods: {
    resetPassword(item){
      this.selectedStaffForReset = item.id
      this.showConfirmationModal = true
    },
    confirm() {

      let data = {
        posDeviceId : this.decryptData(this.$route.params.id),
        staffId : this.selectedStaffForReset
      };

      this.$store.dispatch('exportExcelLoader',true)
      this.makeRequest('post', 'v1/reset-staff-posdevice-password', data).then(callResponse => {

        this.$store.dispatch('exportExcelLoader',false)
        this.showConfirmationModal = false

      });

    },
    terminalConfig(item) {
      this.selectedItem = item
      this.showTerminalConfigModal = true
    },
    sendCall() {

      //extracting ids to send with the request
      const checkedIds = this.staffList
          .filter(staffMember => staffMember.checked)
          .map(staffMember => staffMember.id);

      if(this.mainAccount){
        checkedIds.push(this.mainAccountObj.id)
      }

      let data = {
        posDeviceId: this.decryptData(this.$route.params.id),
        staffIds: JSON.stringify(checkedIds)
      }
      this.loader = true
      this.makeRequest('post', 'v1/manage-pos-devices', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.back();
          }
        }

      });

    },
    async getStaffs() {
      this.mainLoader = true
      this.makeRequest('post', 'v1/get-merchant-staff', {status: 1}, {}, false).then(async callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.tempStaffList = callResponse.response.data.data
            await this.getAlreadySelectedStaffs()
            this.mainLoader = false

          }
        }

      });
    },
   async getAlreadySelectedStaffs() {
      let data = {
        posDeviceId: this.decryptData(this.$route.params.id),
        posDeviceStaff:1
      }
      this.makeRequest('post', 'v1/get-pos-devices', data, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;


          if (code == 200) {
            let res = callResponse.response.data.data



            let alreadySeletedStaffs = []
            let alreadySelectedStaffsMap = []
            let filteredStaff = res.staff

            if( filteredStaff && filteredStaff.length > 0){
              alreadySeletedStaffs = filteredStaff.filter((staffMember) => {
                if(staffMember.id == this.mainAccountObj?.id){
                  this.mainAccountObj = {
                    ...staffMember,
                    username: staffMember?.pivot?.username ?? ''
                  }
                  this.mainAccount = true
                  return false

                }
                return true
              }).map(staffMember => {
                alreadySelectedStaffsMap[staffMember.id] = staffMember?.pivot?.username ?? ''
                alreadySelectedStaffsMap[staffMember.id+'_pivot'] = staffMember?.pivot
                return staffMember.id
              })
            }

            this.staffList = this.tempStaffList.map(staffMember => ({
              ...staffMember,
              username: alreadySelectedStaffsMap[staffMember.id] ?? '',
              pivot: alreadySelectedStaffsMap[staffMember.id+'_pivot'] ?? null,
              checked: alreadySeletedStaffs.includes(staffMember.id)
            }));

          }
        }

      });
    },
  },
}
</script>

